import {
    Button,
    FormGroup,
    Input,
    Segment,
    SegmentContent,
    Select,
} from '@/platform/ui';
import { TrashIcon } from '@heroicons/react/24/outline';

const TYPE_OPTIONS = [
    { id: 'field', name: 'Werknemersveld' },
    { id: 'calculation', name: 'Berekening' },
];

const OPERATOR_OPTIONS = [
    { id: '==', name: 'is gelijk aan' },
    { id: '>', name: 'is groter dan' },
    { id: '<', name: 'is kleiner dan' },
    { id: 'LIKE', name: 'bevat' },
];

const CONNECTOR_OPTIONS = [
    { id: 'AND', name: 'AND' },
    { id: 'OR', name: 'OR' },
];

const Rule = ({ rule, onChange, onDelete, fieldsOptions }) => (
    <Segment>
        <SegmentContent>
            <div className='grid grid-cols-[1fr_auto] items-end gap-4'>
                <FormGroup inline equal>
                    <Select
                        label='Type waarde'
                        options={TYPE_OPTIONS}
                        value={rule?.type || ''}
                        onChange={event =>
                            onChange(rule.id, 'type', event.target.value)
                        }
                    />
                    {rule.type === 'field' ? (
                        <Select
                            label='Veld'
                            placeholder='Selecteer veld'
                            options={fieldsOptions}
                            value={rule?.field || ''}
                            onChange={event =>
                                onChange(rule.id, 'field', event.target.value)
                            }
                        />
                    ) : (
                        <Input
                            label='UID'
                            value={rule?.field || ''}
                            onChange={event =>
                                onChange(rule.id, 'field', event.target.value)
                            }
                        />
                    )}
                    <Select
                        label='Operator'
                        placeholder='Selecteer operator'
                        options={OPERATOR_OPTIONS}
                        value={rule?.operator || ''}
                        onChange={event =>
                            onChange(rule.id, 'operator', event.target.value)
                        }
                    />
                    <Input
                        label='Waarde'
                        value={rule?.value || ''}
                        onChange={event =>
                            onChange(rule.id, 'value', event.target.value)
                        }
                    />
                    <Select
                        label='Connector'
                        options={CONNECTOR_OPTIONS}
                        value={rule?.connector || ''}
                        onChange={event =>
                            onChange(rule.id, 'connector', event.target.value)
                        }
                    />
                </FormGroup>
                <Button
                    variant='danger'
                    type='button'
                    onClick={() => onDelete(rule.id)}
                    aria-label='Verwijder regel'
                >
                    <TrashIcon className='size-5' />
                </Button>
            </div>
        </SegmentContent>
    </Segment>
);

export default Rule;
